'use strict';

/**
 * @classname StockControl
 * @classdesc 在庫メッセージ調整
 */
export default class StockControl {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-item-detail
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		// 送料無料文言の修正
		const $textDeliveryCost = $('.text--delivery-cost');
		if($textDeliveryCost.text() === '送料：0円'){
			$textDeliveryCost
				.addClass('text--red')
				.css('font-size', '18px')
				.addClass('mb20')
				.addClass('fwb')
				.text('送料無料')
				.next('.text--caution')
				.remove();
		}
		// 最近見た商品の設定
		this.setCurrentViewedItem();
		// バリエーション確認
		const variationNum = this.checkVariationNum();
		console.log(`variationNum: ${variationNum}`);
		if(variationNum === 0){
			let stockMessage = stockInfo["0_0"].message || "あり";
			const soldOut = stockInfo["0_0"].is_sold_out;
			if(soldOut) {
				stockMessage = '売り切れ';
				$('.btn--add-cart').prop('disabled', true);
				this._controller.soldOut();
			}
			$('.text--stock-message span').text(stockMessage);
			this._controller._itemStockId = stockInfo["0_0"].item_stock_id;
		}else{
			$('.btn--add-cart').prop('disabled', true);
		}
		this._controller._variationNum = variationNum;
	};


	/**
	 * 最近見た商品の設定
	 *
	 * @memberof StockControl
	 * @return undefined
	 */
	setCurrentViewedItem() {
		if($('body').hasClass('page-preview')) return;
		console.log(`${this.constructor.name}.setCurrentViewedItem`);
		const itemPhotoUrl = $('.block--item-photo .image').attr('src');
		const itemName = $('.heading--item-name').eq(0).text();
		const itemPrice = $('.text--item-price strong').html();
		const item = {
			id: itemId,
			photoUrl: itemPhotoUrl,
			name: itemName,
			price: itemPrice
		}
		let items = localStorage.getItem('viewed_items') || [];
		if(items.length === 0){
			items.push(item);
		} else {
			items = JSON.parse(items);
			let tmp = [];
			tmp.push(item);
			for(let i = 0; i < items.length; i ++){
				const id = items[i].id;
				if(id !== itemId) {
					tmp.push(items[i]);
				}
			}
			// 10商品まで保存
			tmp = tmp.slice(0, 10);
			items = tmp;
		}
		items = JSON.stringify(items);
		localStorage.setItem('viewed_items', items);
	};


	/**
	 * バリエーション数確認
	 *
	 * @memberof StockControl
	 * @return undefined
	 */
	checkVariationNum() {
		console.log(`${this.constructor.name}.checkVariationNum`);
		let num = 0
		if(variationInfo["1"].name) num = 1;
		if(variationInfo["2"].name) num = 2;
		return num;
	};
};
